import React from 'react'

function CompanyLang() {
  return (
    <div className='banner-content'>
      <h1>WELCOME TO SRISTAR GOLD<br /> {/* // language change here /// */}
        COMPANY</h1>
        <h1>శ్రిస్టార్ గోల్డ్ కంపెనీకి<br /> {/* // language change here /// */}
        స్వాగతం</h1>
        <p>విద్య లేదా తిరిగి తాకట్టు పెట్టిన బంగారం — మీ అవసరం ఏదైనా కావొచ్చు,  
మేము మీ బంగారంపై కంటే మీ నమ్మకాన్ని ఎక్కువగా విలువ చేస్తాము!. </p>
<p>Education and Repledged Gold- whatever your need, we value your trust more than your gold!.</p>
      
      <div className='banner-foot'>
        <a href='/about'>
          <button className="btn btn-home" type="button">About Us</button></a>
        <a href='tel:6366333444'>
          <button className="btn btn-home" type="button">Contact Us</button></a>
      </div>

    </div>
  )
}
export default CompanyLang

